// Registrasi Service Worker / PWA
// Aktif hanya di production. Update cache diterapkan otomatis (tanpa sentuh browser).

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

async function clearRuntimeCaches() {
  if (!('caches' in window)) return;

  const cacheNames = await caches.keys();
  // Hapus cache runtime; biarkan precache diganti oleh SW baru
  await Promise.all(
    cacheNames
      .filter((name) => !name.includes('workbox-precache'))
      .map((name) => caches.delete(name))
  );
}

function reloadOnce() {
  let refreshing = false;
  const doReload = () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  };

  navigator.serviceWorker.addEventListener('controllerchange', doReload);
  // Fallback jika controllerchange tidak terpicu (Safari/iPad)
  setTimeout(doReload, 1200);
}

async function activateWaitingWorker(registration) {
  if (!registration) return;

  try {
    await clearRuntimeCaches();
  } catch (_) {
    // lanjut aktivasi SW meski clear cache gagal
  }

  if (registration.waiting) {
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
  }

  reloadOnce();
}

function watchForUpdates(registration) {
  // Update sudah menunggu (mis. dari sesi sebelumnya) → aktifkan otomatis
  if (registration.waiting) {
    console.log('🆕 Service Worker menunggu — mengaktifkan update otomatis...');
    activateWaitingWorker(registration);
    return;
  }

  registration.addEventListener('updatefound', () => {
    const installingWorker = registration.installing;
    if (!installingWorker) return;

    console.log('🔄 Update aplikasi ditemukan, mengunduh...');

    installingWorker.addEventListener('statechange', () => {
      if (installingWorker.state !== 'installed') return;

      if (navigator.serviceWorker.controller) {
        // Ada versi lama → auto-apply tanpa tombol
        console.log('✅ Update siap — menyegarkan aplikasi otomatis...');
        activateWaitingWorker(registration);
      } else {
        console.log('✅ Aplikasi siap dipakai offline.');
      }
    });
  });
}

function scheduleUpdateChecks(registration) {
  const check = () => {
    registration.update().catch(() => {});
  };

  // Cek berkala (30 detik) agar deploy baru cepat terdeteksi di iPad/PWA
  setInterval(check, 30000);

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') check();
  });

  window.addEventListener('online', check);
  window.addEventListener('focus', check);
}

export function register(config) {
  if (process.env.NODE_ENV !== 'production') {
    console.log('🛈 PWA/Service Worker dinonaktifkan di development.');
    unregisterAndClearCaches();
    return;
  }

  if (!('serviceWorker' in navigator)) {
    console.warn('Service Worker tidak didukung di browser ini.');
    return;
  }

  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
  if (publicUrl.origin !== window.location.origin) {
    return;
  }

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    if (isLocalhost) {
      checkValidServiceWorker(swUrl, config);
    } else {
      registerValidSW(swUrl, config);
    }
  });
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log('✅ Service Worker aktif (production):', registration.scope);

      watchForUpdates(registration);
      scheduleUpdateChecks(registration);

      if (config && config.onSuccess && !navigator.serviceWorker.controller) {
        config.onSuccess(registration);
      }
    })
    .catch((error) => {
      console.error('❌ Gagal mendaftarkan service worker:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        unregisterAndClearCaches().then(() => {
          window.location.reload();
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('Tidak ada koneksi. App berjalan dalam mode offline.');
    });
}

async function unregisterAndClearCaches() {
  if (!('serviceWorker' in navigator)) return;

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((reg) => reg.unregister()));
    if ('caches' in window) {
      const names = await caches.keys();
      await Promise.all(names.map((name) => caches.delete(name)));
    }
    console.log('🧹 Service Worker & cache dibersihkan (development).');
  } catch (error) {
    console.error(error.message);
  }
}

export function unregister() {
  unregisterAndClearCaches();
}
